import { firstValueFrom } from 'rxjs';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { get as getProjection } from 'ol/proj';
import { HttpService } from 'src/app/services/http.service';

const pendingRegistrations = new Map<string, Promise<boolean>>();

/** Normalise un code EPSG ("31370", 31370, "EPSG:31370") en "EPSG:31370" ; null si le code est absent ou invalide. */
export function normalizeEpsgCode(epsg: string | number | null | undefined): string | null {
  if (epsg === null || epsg === undefined) return null;
  const digits = String(epsg).replace(/^EPSG:/i, '').trim();
  return /^\d+$/.test(digits) && Number(digits) > 0 ? `EPSG:${digits}` : null;
}

/**
 * Garantit que la projection est connue d'OpenLayers en récupérant sa définition proj4 auprès de l'API si besoin.
 * Les appels concurrents pour un même code partagent la même requête ; un échec autorise une nouvelle tentative.
 */
export function ensureProjection(http: HttpService, epsg: string | number | null | undefined): Promise<boolean> {
  const code = normalizeEpsgCode(epsg);
  if (!code) return Promise.resolve(false);
  if (getProjection(code)) return Promise.resolve(true);

  const pending = pendingRegistrations.get(code);
  if (pending) return pending;

  const registration = firstValueFrom(http.get<string>(`Sites/proj4/${code.split(':')[1]}`))
    .then(definition => {
      if (!definition) return false;
      proj4.defs(code, definition);
      register(proj4);
      return !!getProjection(code);
    })
    .catch(() => false)
    .then(registered => {
      if (!registered) pendingRegistrations.delete(code);
      return registered;
    });

  pendingRegistrations.set(code, registration);
  return registration;
}
